
import {
  BieRecordId,
  //IBieApiError,
  //IBieApiResponse,
  IBieOnboardingValidateAndRefreshResult,
  IBieOnboardingValidateAndRefreshResults,
  IBieOnboardingValidateRequest,
  IBieOnboardingValidationIssue,
  IBieOnboardingValidationRule,
  IBieOnboardingValidationSummary,
  IBieOnboardingWorkbench,
  IBieOnboardingWorkbookValidationResult,
  IBieValidationIssueFindRequest,
  IBieValidationRuleFindRequest,
} from './bieonboardingworkbench.models';


import { json, postBiz, rows } from '../core/coreapi';
// import {
//   normalizeHistoricalFactRow,
//   normalizeHistoricalImportRow,
// } from './bieHistorical.normalize';


import {
  normalizeBlocking,
  normalizeClassCode,
  normalizeCode,
  normalizeImportId,
  normalizeImportItemId,
  normalizeLoadSessionId,
  normalizeRuleCode,
  normalizeSearch,
  normalizeSeverityCode,
} from './bieonboarding.normalize';

import { normalizeLoadSessionStamp, normalizePageLimit, normalizePageOffset } from './bieonboarding.normalize';
import { IBieOnboardingImportRecord } from './bieonboarding.import.models';
import { normalizeImportRecord } from './bieonboarding.import.normalize';

// import {
//   validateBieOnboardingWorkbook,
// } from './bieonboardingworkbook.apis';

// import {
//   BieOnboardingWorkbookOperationResult,
// } from './bieonboardingworkbook.models';

// import {
//   //IBieOnboardingValidateAndRefreshResult,
//   IBieOnboardingWorkbookValidation,
// } from './bieonboardingworkbench.models';

const REVIEWSERVICE = 'bieonboardingreview';
const IMPORTSERVICE = 'bieonboardingimport';

// Review Workbench

export const fetchBieOnboardingWorkbench = async (loadSessionId: BieRecordId) =>
  json(await postBiz({
    s: REVIEWSERVICE,
    a: 'get',
    lsi: normalizeLoadSessionId(loadSessionId),
  })) as IBieOnboardingWorkbench;

export const fetchBieOnboardingValidationSummary = async (loadSessionId: BieRecordId) =>
  json(await postBiz({
    s: REVIEWSERVICE,
    a: 'summary',
    lsi: normalizeLoadSessionId(loadSessionId),
  })) as IBieOnboardingValidationSummary;

export const fetchBieOnboardingValidationIssues = async (request: IBieValidationIssueFindRequest,): Promise<IBieOnboardingValidationIssue[]> =>
  rows(await postBiz({
    s: REVIEWSERVICE,
    a: 'issuefind',
    lsi: normalizeLoadSessionId(request?.loadSessionId),
    imi: normalizeImportId(request?.importId),
    iii: normalizeImportItemId(request?.importItemId),
    svc: normalizeSeverityCode(request?.severityCode),
    ruc: normalizeRuleCode(request?.ruleCode),
    clc: normalizeClassCode(request?.classCode),
    blk: normalizeBlocking(request?.blocking),
    sch: normalizeSearch(request?.search),
    sts: normalizeImportId(request?.status),
    pos: normalizePageOffset(request.pageOffset),
    plm: normalizePageLimit(request.pageLimit),
  })); //.map(normalizeHistoricalImportRow);

export const fetchBieOnboardingValidationRules = async (request: IBieValidationRuleFindRequest = {}): Promise<
  IBieOnboardingValidationRule[]
> =>
  rows(await postBiz({
    s: REVIEWSERVICE,
    a: 'rulefind',
    svc: normalizeSeverityCode(request?.severityCode),
    blk: normalizeBlocking(request?.blocking),
    sch: normalizeSearch(request?.search),
    sts: normalizeImportId(request?.status),
  })); //.map(normalizeHistoricalImportRow);


// Import Workbenches


export const fetchBieOnboardingImports = async (request: any) =>
  rows(await postBiz({
    s: IMPORTSERVICE,
    a: 'find',
    lsi: normalizeLoadSessionId(request?.loadSessionId),
    icc: normalizeClassCode(request?.classCode),
    sch: normalizeSearch(request?.search),
    sts: normalizeImportId(request?.status),
    pos: normalizePageOffset(request.pageOffset),
    plm: normalizePageLimit(request.pageLimit),
  }));

export const fetchBieOnboardingSummary = async (loadSessionId: any,) =>
  json(await postBiz({
    s: IMPORTSERVICE,
    a: 'summary',
    lsi: normalizeLoadSessionId(loadSessionId),
  })) as IBieOnboardingValidateAndRefreshResult;

export const fetchBieOnboardingImportItems = async (request: any,) =>
  rows(await postBiz({
    s: IMPORTSERVICE,
    a: 'itemfind',
    //lsi: normalizeLoadSessionId(loadSessionId),
    //:imi,:vac,:rst,:rcc,:sch,:sts,:pos,:plm
    //stp: normalizeLoadSessionStamp(request?.stamp),
    imi: normalizeImportId(request?.importId),
    vac: normalizeCode(request?.validationCode),
    rst: normalizeCode(request?.resolutionStatus),
    rcc: normalizeClassCode(request?.recordClassCode),
    sch: normalizeSearch(request?.search),
    sts: normalizeImportId(request?.status),
    pos: normalizePageOffset(request.pageOffset),
    plm: normalizePageLimit(request.pageLimit),
  })).map(normalizeImportRecord) as IBieOnboardingImportRecord[];


export const fetchBieOnboardingImportItem = async (importItemId: any) =>
  normalizeImportRecord(
    json(await postBiz({
      s: IMPORTSERVICE,
      a: 'itemget',
      rid: normalizeLoadSessionId(importItemId),
    }))
  ) as IBieOnboardingImportRecord;

export const fetchBieOnboardingClear = async (request: any,) =>
  json(await postBiz({
    s: 'onboarding',
    a: 'workbench',
    lsi: normalizeLoadSessionId(request?.loadSessionId),
    cfm: request?.notes,
    stp: normalizeLoadSessionStamp(request?.stamp),
  })) as IBieOnboardingValidateAndRefreshResult;

// onboarding extended



// export async function validateBieOnboardingWorkbook(
//   loadSessionId: BieRecordId,
//   stamp: string,
// ): Promise<
//   IBieOnboardingValidateAndRefreshResult
// > {
//   return bieOnboardingWorkbenchApi
//     .validateWorkbook(
//       loadSessionId,
//       {
//         stamp,
//       },
//     );
// }



// export const validateBieOnboardingWorkbook = async (loadSessionId: BieRecordId, request: IBieOnboardingValidateRequest,) =>
//   json(await postBiz({
//     s: 'onboarding',
//     a: 'workbench',
//     lsi: normalizeLoadSessionId(loadSessionId),
//     stp: normalizeLoadSessionStamp(request?.stamp),
//   })) as IBieOnboardingValidateAndRefreshResult;

// export async function validateAndRefreshBieOnboardingWorkbench0(
//   loadSessionId: BieRecordId,
//   stamp: string,
// ): Promise<IBieOnboardingValidateAndRefreshResult> {
//   const validation =
//     await validateBieOnboardingWorkbook(
//       Number(loadSessionId),
//       stamp,
//     );

//   const workbench =
//     await fetchBieOnboardingWorkbench(
//       loadSessionId,
//     );

//   return {
//     validation,
//     workbench,
//   };
// }

// export async function validateBieOnboardingWorkbook(
//   loadSessionId: BieRecordId,
//   stamp: string,
// ): Promise<IBieOnboardingWorkbookValidationResult> {
//   const response = await postBiz({
//     s: 'onboardingworkbook',
//     a: 'validate',

//     lsi: normalizeLoadSessionId(loadSessionId),
//     stp: normalizeLoadSessionStamp(stamp),
//   });

//   return normalizeBieOnboardingWorkbookValidationResult(
//     json(response),
//   );
// }

// export async function validateAndRefreshBieOnboardingWorkbench(
//   loadSessionId: BieRecordId,
//   stamp: string,
// ): Promise<IBieOnboardingValidateAndRefreshResults> {
//   const validation =
//     await validateBieOnboardingWorkbook(
//       Number(loadSessionId),
//       stamp,
//     );

//   const workbench =
//     await fetchBieOnboardingWorkbench(
//       loadSessionId,
//     );

//   return {
//     validation,
//     workbench,
//   };
// }


